import type { HeaderProps } from '../ui/header.tsx';
import { Header } from '../ui/header.tsx';

export function SectionHeader(props: HeaderProps) {
    return <Header className="gap-2" {...props} />;
}
